export const FEECONDITIONS = [
    {
        "id": "66d05955f21f8f6919df63b8",
        "code": "TRANSFER_TYPE",
        "description": "Transfer types (Source and destination account combinations)",
        "type": "string",
        "regex": "^([A-Z0-9]{3,15})$",
        "values": [],
        "created": "2024-08-29T11:19:49.992Z",
        "modified": "2024-08-29T11:19:49.992Z"
    },
    {
        "id": "66d05955f21f8f6919df63b7",
        "code": "TRANSACTION_ORIGIN",
        "description": "Origin of transaction (Domestic or International)",
        "type": "string",
        "regex": "^(DOMESTIC|FOREIGN)$",
        "values": ['DOMESTIC', 'FOREIGN'],
        "created": "2024-08-29T11:19:49.992Z",
        "modified": "2024-08-29T11:19:49.992Z"
    },
    {
        "id": "66d05957f21f8f6919df6400",
        "code": "SOURCEOFFUNDS",
        "description": "Source of funds",
        "type": "integer",
        "regex": "^([0,9]{1,2})$",
        "values": [],
        "created": "2024-08-29T11:19:51.616Z",
        "modified": "2024-08-29T11:19:51.616Z"
    },
    {
        "id": "66d05957f21f8f6919df6401",
        "code": "SOURCECITY",
        "description": "Source city",
        "type": "integer",
        "regex": "^([0,9])$",
        "values": [],
        "created": "2024-08-29T11:19:51.616Z",
        "modified": "2024-08-29T11:19:51.616Z"
    },
    {
        "id": "6650a27bdfb4e06ef57e0ab8",
        "code": "SCHEME_SCOPE",
        "description": "Payment Scheme",
        "type": "string",
        "regex": "^(VISA|MASTERCARD|MERCURY|UNIONPAY|ONELINK|PAYSYS)$",
        "values": ['VISA', 'MASTERCARD', 'MERCURY', 'UNIONPAY', 'ONELINK', 'PAYSYS'],
        "created": "2024-07-08T00:11:57.488Z",
        "modified": "2024-07-08T00:11:57.488Z"
    },
    {
        "id": "66d05957f21f8f6919df63fe",
        "code": "RECEIVER_CURRENCY",
        "description": "The currency in which the transaction amount will be received",
        "type": "string",
        "regex": "^([A-Z]{3,3})$",
        "values": [],
        "created": "2024-08-29T11:19:51.616Z",
        "modified": "2024-08-29T11:19:51.616Z"
    },
    {
        "id": "66d05957f21f8f6919df63fc",
        "code": "RECEIVER_COUNTRY",
        "description": "Receiver country where transaction amount is being sent",
        "type": "string",
        "regex": "^([A-Z]{3,3})$",
        "values": [],
        "created": "2024-08-29T11:19:51.616Z",
        "modified": "2024-08-29T11:19:51.616Z"
    },
    {
        "id": "66d05957f21f8f6919df63ff",
        "code": "PURPOSEOFREMITTANCEID",
        "description": "Purpose of remittance",
        "type": "integer",
        "regex": "^([0,9]{1,2})$",
        "values": [],
        "created": "2024-08-29T11:19:51.616Z",
        "modified": "2024-08-29T11:19:51.616Z"
    },
    {
        "id": "66d05955f21f8f6919df63b9",
        "code": "PURCHASE_TYPE",
        "description": "Purchase Types",
        "type": "string",
        "regex": "^(ECOMMERCE|PURCHASE)$",
        "values": ['ECOMMERCE', 'PURCHASE'],
        "created": "2024-08-29T11:19:49.992Z",
        "modified": "2024-08-29T11:19:49.992Z"
    },
    {
        "id": "66d05957f21f8f6919df63fd",
        "code": "PAYMENT_TYPE",
        "description": "Type of payment sent",
        "type": "string",
        "regex": "^(C|2|g)$",
        "values": [],
        "created": "2024-08-29T11:19:51.616Z",
        "modified": "2024-08-29T11:19:51.616Z"
    }
]